export const gridLetters = ['सु', 'प्र', 'उ', 'बि', 'हो', 'मु', 'ग', 'ब', 'सु', 'नु', 'बि', 'घ', 'धि', 'इ', 'द', 'र', 'रु', 'फ', 'सि', 'सि', 'रहिं', 'बस', 'हि', 'मं', 'ल', 'न', 'ल', 'य', 'न', 'अं', 'सुज', 'सो', 'ग', 'सु', 'कु', 'म', 'स', 'ग', 'त', 'न', 'ई', 'ल', 'धा', 'बे', 'नो', 'त्य', 'र', 'न', 'कु', 'जो', 'म', 'रि', 'र', 'र', 'अ', 'की', ' हो', 'सं', 'रा', 'य', 'पु', 'सु', 'थ', 'सी', 'जे', 'इ', 'ग', 'म', 'सं', 'क', 'रे', 'हो', 'स', 'स', 'नि', 'त', 'र', 'त', 'र', 'स', 'हूँ', 'ह', 'ब', 'ब', 'प', 'चि', 'स', 'हिं', 'स', 'तु', 'म', 'का', 'ा', 'र', 'र', 'म', 'मि', 'मी', 'म्हा', 'ा', 'जा', 'हू', 'हीं', 'ा', 'ा', 'ता', 'रा', 'रे', 'री', 'हृ', 'का', 'फ', 'खा', 'जू', 'ई', 'र', 'रा', 'पू', 'द', 'ल', 'नि', 'को', 'जो', 'गो', 'न', 'मु', 'जि', 'यँ', 'ने', 'मनि', 'क', 'ज', 'प', 'स', 'ल', 'हि', 'रा', 'मि', ' स', 'रि', 'ग', 'द', 'न्मु', 'ख', 'म', 'खि', 'जि', 'म', 'त', 'जं', 'सिं', 'ख', 'नु', 'न', 'कौ', 'मि', 'निज', 'र्क', 'ग', 'धु', 'ध', 'सु', 'का', 'स', 'र', 'गु', 'ब', 'म', 'अ', 'रि', 'नि', 'म', 'ल', 'ा', 'न', 'ढँ', 'ती', 'न', 'क', 'भ', 'ना', 'पु', 'व', 'अ', 'ा', 'र', 'ल', 'ा', 'ए', 'तु', 'र', 'न', 'नु', 'वै', 'थ', 'सि', 'हूँ', 'सु', 'म्ह','रा', 'र', 'स', 'स', 'र', 'त', 'न', 'ख', 'ा', 'ज', 'ा', 'र', 'ा', 'ा', 'ला', 'धी', 'ा', 'री', 'ा', 'हू', 'हीं', 'खा', 'जू', 'ई', 'रा', 'रे']

export const chaupayian = [
    {
        id : 0,
        chaupai : "सुनु सिय सत्य असीस हमारी। पूजिहि मन कामना तुम्हारी।।",
        context : "यह चौपाई बालकाण्ड में श्रीसीताजी के गौरीपूजन के प्रसंग में है। गौरीजी ने श्रीसीताजी को आशीर्वाद दिया है।",
        fal: "प्रश्नकर्त्ता का प्रश्न उत्तम है, कार्य सिद्ध होगा।"
    },
    {
        id : 1,
        chaupai : "प्रबिसि नगर कीजै सब काजा। हृदय राखि कोसलपुर राजा।",
        context : "यह चौपाई सुन्दरकाण्ड में हनुमानजी के लंका में प्रवेश करने के समय की है।",
        fal: "भगवान् का स्मरण करके कार्यारम्भ करो, सफलता मिलेगी।"
    },
    {
        id : 2,
        chaupai : "उघरें अंत न होइ निबाहू। कालनेमि जिमि रावन राहू।।",
        context : "यह चौपाई बालकाण्ड के आरम्भ में सत्संग-वर्णन के प्रसंग में है।",
        fal: "इस कार्य में भलाई नहीं है। कार्य की सफलता में सन्देह है।"
    },
    {
        id : 3,
        chaupai : "बिधि बस सुजन कुसंगत परहीं। फनि मनि सम निज गुन अनुसरहीं।।",
        context : "यह चौपाई बालकाण्ड के आरम्भ में सत्संग-वर्णन के प्रसंग में है।",
        fal: "खोटे मनुष्यों का संग छोड़ दो। कार्य की सफलता में सन्देह है।"
    },
    {
        id : 4,
        chaupai : "होइ है सोई जो राम रचि राखा। को करि तरक बढ़ावहिं साषा।।",
        context : "यह चौपाई बालकाण्डान्तर्गत शिव और पार्वती के संवाद में है।",
        fal: "कार्य होने में सन्देह है, अतः उसे भगवान् पर छोड़ देना श्रेयष्कर है।"
    },
    {
        id : 5,
        chaupai : "मुद मंगलमय संत समाजू। जिमि जग जंगम तीरथ राजू।।",
        context : "यह चौपाई बालकाण्ड में संत-समाजरुपी तीर्थ के वर्णन में है।",
        fal: "प्रश्न उत्तम है। कार्य सिद्ध होगा।"
    },
    {
        id : 6,
        chaupai : "गरल सुधा रिपु करय मिताई। गोपद सिंधु अनल सितलाई।।",
        context : "यह चौपाई श्रीहनुमान् जी के लंका प्रवेश करने के समय की है।",
        fal: "प्रश्न बहुत श्रेष्ठ है। कार्य सफल होगा।"
    },
    {
        id : 7,
        chaupai : "बरुन कुबेर सुरेस समीरा। रन सनमुख धरि काह न धीरा।।",
        context : "यह चौपाई लंकाकाण्ड में रावन की मृत्यु के पश्चात् मन्दोदरी के विलाप के प्रसंग में है।",
        fal: "कार्य पूर्ण होने में सन्देह है।"
    },
    {
        id : 8,
        chaupai : "सुफल मनोरथ होहुँ तुम्हारे। राम लखनु सुनि भए सुखारे।।",
        context : "यह चौपाई बालकाण्ड पुष्पवाटिका से पुष्प लाने पर विश्वामित्रजी का आशीर्वाद है।",
        fal: "प्रश्न बहुत उत्तम है। कार्य सिद्ध होगा।"
    },
    

    
]